import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Icon,
  SimpleGrid,
  ModalFooter,
  Button,
  FormControl,
  FormLabel,
  useToast,
  Box,
  Text,
  Select,
  MenuItem,
} from "@chakra-ui/react";
import {
  FaEdit,
  FaCalendarAlt,
  FaTags,
  FaLayerGroup,
  FaChalkboardTeacher,
  FaUsers,
  FaUser,
  FaUserTie,
} from "react-icons/fa"; // For the edit icon
import { BASE_URL } from "../../../Globalapi/Globalapi";

const Edit_Reg_student = ({ reg_id }) => {
  const toast = useToast();

  const [showModal, setShowModal] = useState(false);
  const [eventData, setEventData] = useState(null);
  const [events, setEvents] = useState([]); // State for storing event list
  const [categories, setCategories] = useState([]); // State for storing filtered categories
  const [subCategories, setSubCategories] = useState([]); // State for storing filtered sub-categories
  const [selectedEvent, setSelectedEvent] = useState(null); // Track the selected event
  const [selectedCategory, setSelectedCategory] = useState(null); // Track the selected category
  const [selectedSubCategory, setSelectedSubCategory] = useState(null); // Track the selected sub-category

  // Fetch event data for registration details
  useEffect(() => {
    if (reg_id) {
      console.log("Fetching event data for reg_id:", reg_id);
      fetch(
        `${BASE_URL}/admin/events/registration/view_reg.php?reg_id=${reg_id}`
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            console.log("Fetched event registration data:", data.data);
            setEventData(data.data);
            setSelectedEvent(data.data.event_id); // Set initial event on data load
            setSelectedCategory(data.data.category_id); // Set selected category from event data
            setSelectedSubCategory(data.data.sub_category_id); // Pre-select the sub-category from event data
          } else {
            console.error(
              "Failed to fetch event registration data:",
              data.message
            );
          }
        })
        .catch((error) =>
          console.error("Error fetching event registration:", error)
        );
    }
  }, [reg_id]);

  // Fetch events for dropdown
  useEffect(() => {
    const school_id = sessionStorage.getItem("school_id"); // Replace with actual school_id if available
    console.log("Fetching events for school_id:", school_id);
    fetch(
      `${BASE_URL}/admin/events/event/list_all_event.php?school_id=${school_id}`
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          console.log("Fetched events data:", data.data.events); // Log the events data
          setEvents(data.data.events); // Set the events to state
        } else {
          console.error("Failed to fetch events:", data.message);
        }
      })
      .catch((error) => console.error("Error fetching events:", error));
  }, []);

  // Fetch categories for the selected event
  useEffect(() => {
    if (selectedEvent) {
      const school_id = sessionStorage.getItem("school_id"); // Replace with actual school_id if available
      console.log(
        "Fetching categories for selectedEvent:",
        selectedEvent,
        "with school_id:",
        school_id
      );
      fetch(
        `${BASE_URL}/admin/events/category/list_category.php?school_id=${school_id}`
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            console.log("Fetched categories data:", data.data); // Log the categories data
            // Filter categories based on the selected event's event_id
            const filteredCategories = data.data.filter(
              (category) => category.event_id === selectedEvent
            );
            console.log("Filtered categories:", filteredCategories);
            setCategories(filteredCategories); // Set the filtered categories to state
          } else {
            console.error("Failed to fetch categories:", data.message);
          }
        })
        .catch((error) => console.error("Error fetching categories:", error));
    }
  }, [selectedEvent]);

  // Fetch sub-categories for the selected category
  useEffect(() => {
    if (selectedCategory) {
      const school_id = sessionStorage.getItem("school_id"); // Replace with actual school_id if available
      console.log(
        "Fetching sub-categories for school_id:",
        school_id,
        "with selectedEvent:",
        selectedEvent,
        "and selectedCategory:",
        selectedCategory
      );

      fetch(
        `${BASE_URL}/admin/events/sub_category/list_subcat.php?school_id=${school_id}`
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            console.log("Fetched sub-categories data:", data.data); // Log the full data received from the API

            // Filter sub-categories based on the selected event and category
            const filteredSubCategories = data.data.flatMap(
              (
                event // Flatten out the categories and subcategories
              ) =>
                event.categories
                  .filter(
                    (category) =>
                      category.category_id === selectedCategory &&
                      event.event_id === selectedEvent
                  )
                  .flatMap((category) =>
                    category.sub_categories.map((subCategory) => ({
                      value: subCategory.subcat_id,
                      label: subCategory.sub_category,
                    }))
                  )
            );

            console.log("Filtered sub-categories:", filteredSubCategories); // Log the filtered sub-categories
            setSubCategories(filteredSubCategories); // Set the filtered sub-categories

            // Set the selected sub-category based on eventData (pre-selection)
            if (eventData) {
              console.log("eventData:", eventData);

              const preSelectedSubCategory = filteredSubCategories.find(
                (subCategory) => subCategory.value === eventData.subcategory_id
              );

              console.log("preSelectedSubCategory:", preSelectedSubCategory);

              const selectedSubCategoryValue = preSelectedSubCategory
                ? preSelectedSubCategory.value
                : null;
              console.log(
                "selectedSubCategoryValue:",
                selectedSubCategoryValue
              );

              setSelectedSubCategory(selectedSubCategoryValue);
            }
          } else {
            console.error("Failed to fetch sub-categories:", data.message);
          }
        })
        .catch((error) =>
          console.error("Error fetching sub-categories:", error)
        );
    }
  }, [selectedEvent, selectedCategory, eventData]);

  // Toggle modal visibility
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  // Handle event change in dropdown
  const handleEventChange = (event) => {
    console.log("Event changed to:", event.target.value);
    setSelectedEvent(event.target.value);
  };

  // Handle category change in dropdown
  const handleCategoryChange = (event) => {
    console.log("Category changed to:", event.target.value);
    setSelectedCategory(event.target.value);
  };

  // Handle sub-category change in dropdown
  const handleSubCategoryChange = (event) => {
    console.log("Sub-category changed to:", event.target.value);
    setSelectedSubCategory(event.target.value);
  };

  // Handle form submission and log the data
  const handleSubmit = () => {
    const submittedData = {
      reg_id, // Ensure the registration ID is included
      event_id: selectedEvent,
      category_id: selectedCategory,
      sub_category_id: selectedSubCategory,
      school_id: sessionStorage.getItem("school_id"), // Replace with the actual school_id
      student_id: eventData.student_id, // Ensure the student ID is included from eventData
      user_id: sessionStorage.getItem("user_id"),
      class_id: eventData.class_id,
      division_id: eventData.division_id,
    };

    console.log("Submitting data:", submittedData);

    fetch(`${BASE_URL}/admin/events/registration/edit_reg.php`, {
      method: "PUT", // Use PUT method as per the API
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(submittedData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          console.log("Data submitted successfully:", data.message);
          toast({
            title: "Event Registration Updated",
            description: "Event registration updated successfully.",
            status: "success",
            duration: 5000,
            isClosable: true,
          });
          handleCloseModal(); // Close modal on success
        } else {
          console.error("Error submitting data:", data.message);
          toast({
            title: "Failed to Update Event Registration",
            description: "There was an issue updating the event registration.",
            status: "error",
            duration: 5000,
            isClosable: true,
          });
        }
      })
      .catch((error) => {
        console.error("Error submitting data:", error);
        toast({
          title: "Error Occurred",
          description: "An error occurred while updating event registration.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      });
  };

  return (
    <div>
      {/* Button to trigger modal */}
      <MenuItem size="sm" onClick={handleShowModal}>
        <FaEdit style={{ marginRight: "8px", color: "blue" }} /> Edit
      </MenuItem>

      {/* Modal with event data */}
      {eventData && (
        <Modal
          isOpen={showModal}
          onClose={handleCloseModal}
          size="lg"
          motionPreset="slideInBottom"
        >
          <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
          <ModalContent
            borderRadius="lg"
            boxShadow="xl"
            bg="linear-gradient(135deg, #e0f7f7, #f0ffff)"
            color="gray.700"
            p={6}
            maxW="700px"
            maxH="550px"
            overflowY="auto"
          >
            <ModalHeader
              fontSize="xl"
              fontWeight="bold"
              textAlign="center"
              color="teal.600"
            >
              {" "}
              <Icon as={FaEdit} boxSize={5} mr={2} />
              Event Registration Details
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody
              overflowY="auto"
              px={4}
              css={{
                "&::-webkit-scrollbar": {
                  width: "6px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "rgba(255, 255, 255, 0.2)",
                  borderRadius: "10px",
                  backdropFilter: "blur(8px)",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "rgba(173, 216, 230, 0.6)",
                  borderRadius: "10px",
                  backdropFilter: "blur(8px)",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "rgba(173, 216, 230, 0.9)",
                },
              }}
            >
              <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                {/* Event Dropdown */}
                <FormControl>
                  <FormLabel>
                    <Icon as={FaCalendarAlt} mr={1} color="teal.500" />
                    Event
                  </FormLabel>
                  <Select
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    placeholder="Select Event"
                    value={selectedEvent} // Control the selected event
                    onChange={handleEventChange} // Update the event selection
                  >
                    {events.map((event) => (
                      <option key={event.id} value={event.id}>
                        {event.event_title}
                      </option>
                    ))}
                  </Select>
                </FormControl>

                {/* Category Dropdown */}
                <FormControl >
                  <FormLabel>
                    <Icon as={FaTags} mr={1} color="teal.500" />
                    Category
                  </FormLabel>
                  <Select
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    placeholder="Select Category"
                    value={selectedCategory} // Control the selected category
                    onChange={handleCategoryChange} // Update the category selection
                  >
                    {categories.map((category) => (
                      <option key={category.id} value={category.id}>
                        {category.category}
                      </option>
                    ))}
                  </Select>
                </FormControl>

                {/* Sub-category Dropdown */}
                <FormControl mt={4}>
                  <FormLabel>
                    <Icon as={FaLayerGroup} mr={1} color="teal.500" />
                    Sub-Category
                  </FormLabel>
                  <Select
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    placeholder="Select Sub-Category"
                    value={selectedSubCategory} // Control the selected sub-category
                    onChange={handleSubCategoryChange} // Update the sub-category selection
                  >
                    {subCategories.map((subCategory) => (
                      <option key={subCategory.value} value={subCategory.value}>
                        {subCategory.label}
                      </option>
                    ))}
                  </Select>
                </FormControl>

                {/* Display additional data */}
                <FormControl mt={4}>
                  <FormLabel>
                    <Icon as={FaChalkboardTeacher} mr={1} color="teal.500" />
                    Class
                  </FormLabel>
                  <Box p={2} borderWidth={1} borderRadius="md">
                    <Text>{eventData.class}</Text>
                  </Box>
                </FormControl>

                <FormControl mt={4}>
                  <FormLabel>
                    <Icon as={FaUsers} mr={1} color="teal.500" />
                    Division
                  </FormLabel>
                  <Box p={2} borderWidth={1} borderRadius="md">
                    <Text>{eventData.division}</Text>
                  </Box>
                </FormControl>

                <FormControl mt={4}>
                  <FormLabel>
                    <Icon as={FaUser} mr={1} color="teal.500" />
                    Student Name
                  </FormLabel>
                  <Box p={2} borderWidth={1} borderRadius="md">
                    <Text>{eventData.student_name}</Text>
                  </Box>
                </FormControl>

                <FormControl mt={4}>
                  <FormLabel>
                    <Icon as={FaUserTie} mr={1} color="teal.500" />
                    Staff Name
                  </FormLabel>
                  <Box p={2} borderWidth={1} borderRadius="md">
                    <Text>{eventData.staff_name}</Text>
                  </Box>
                </FormControl>
              </SimpleGrid>
            </ModalBody>

            <ModalFooter>
              {/* <Button variant="ghost" onClick={handleCloseModal}>
                Close
              </Button> */}
              <Button
                bgGradient="linear(to-r, teal.400, teal.600)"
                color="white"
                _hover={{ bgGradient: "linear(to-r, teal.500, teal.700)" }}
                onClick={handleSubmit}
              >
                Save
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}
    </div>
  );
};

export default Edit_Reg_student;
